import React, { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ApplicationNavigation from "constants/navigation/applicationNavigation";
import SkippedTasksContent from "./SkippedTasksContent";

function SkippedTasks() {
	// Init params
	const { id } = useParams();

	// Init hooks
	const location = useLocation();
	const { t } = useTranslation();

	// Init state
	const [is404, setIs404] = useState(false);
	const navigation = ApplicationNavigation(id);

	// Rendering pauses content with Navbar. Otherwise, 404 error
	if (is404 === false) {
		return (
			<SkippedTasksContent
				navigation={navigation}
				id={id}
				setIs404={setIs404}
				state={location.state}
			/>
		);
	} else {
		return <p>{t("message.applicationIdNotExist", { id })}</p>;
	}
}

export default SkippedTasks;
